import { Box, Tab, Tabs } from '@mui/material';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { DialogProvider, Layout } from '@cnx-saas/common-fe';
import { useAuth } from '@cnx-saas/react-auth';
import { UserType } from '@cnx-saas/common';
import { PathEnum } from '../navigation/sidebar/sidebar.type';
import { ExistingUsers } from './user-tables/ExistingUsers';
import { Invite } from './user-tables/Invite';
import { InvitedUsers } from './user-tables/InvitedUsers';

export function UserManagement() {
  const [value, setValue] = React.useState(0);
  const { t } = useTranslation();
  const { user } = useAuth(true);
  const [refetchFunction, setRefetchFunction] = React.useState<
    (() => void) | null
  >(null);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const handleRefetch = (refetch: () => void) => {
    setRefetchFunction(() => refetch);
  };

  const handleOnInviteUsers = () => {
    if (refetchFunction) {
      refetchFunction();
    }
  };

  return (
    <DialogProvider>
      {user.userType !== UserType.TEAM_ADMIN ? (
        <Redirect />
      ) : (
        <Layout
          title={t('userManagement.title', {
            defaultValue: 'User Mangement',
          })}
        >
          <Invite onInviteUsers={handleOnInviteUsers} />

          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="basic tabs example"
            >
              <Tab
                sx={{ width: '50%', maxWidth: '1000px' }}
                label={t('userManagement.tab.existingUsers', {
                  defaultValue: 'Existing Users',
                })}
              />
              <Tab
                sx={{ width: '50%', maxWidth: '1000px' }}
                label={t('userManagement.tab.invitedUsers', {
                  defaultValue: 'Invited Users',
                })}
              />
            </Tabs>
          </Box>
          {value === 0 ? (
            <ExistingUsers onRefetch={handleRefetch} />
          ) : (
            <InvitedUsers onRefetch={handleRefetch} />
          )}
        </Layout>
      )}
    </DialogProvider>
  );
}

function Redirect() {
  const navigate = useNavigate();
  const { user } = useAuth(true);

  useEffect(() => {
    if (user.userType !== UserType.TEAM_ADMIN) {
      navigate(PathEnum.PATH_DASHBOARD);
    }
  });

  return <div>403 Forbidden / 403 Verboten</div>;
}
